import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EnvironmentConfiguration, ENVIRONMENT_CONFIG } from 'src/environments/models/environment.model';
import { Plant } from '../models/plant';

@Injectable({
  providedIn: 'root',
})
export class ReportService {
  private httpClient = inject(HttpClient);
  environment = inject<EnvironmentConfiguration>(ENVIRONMENT_CONFIG);

  baseUrl = "";
  constructor() {
    this.baseUrl = this.environment.serviceCall.baseURL!;
    this.baseUrl = this.baseUrl.slice(-1) === '/' ? this.baseUrl : this.baseUrl + '/';
    this.baseUrl = `${this.baseUrl}`;
  }


  getPlants(): Observable<Plant[]> {
    return this.httpClient.get<Plant[]>(`${this.baseUrl}Plant`);
  }

  getMonths(plantId: string): Observable<string[]> {
    return this.httpClient.get<string[]>(`${this.baseUrl}Plant/plantsPeriod/${plantId}`);
  }

  getReportsAnalyses(plantId: string, monthStart: string, monthEnd?: string): Observable<any> {
    const startDate = this.formatDateToISO(monthStart, 'start');
    const endDate = this.formatDateToISO(monthEnd || monthStart, 'end');
    const url = `${this.baseUrl}ReportAnalysis/getReportAnalyses?plantId=${plantId}&start=${startDate}&end=${endDate}`;
    return this.httpClient.get<any>(url);
  }

  private formatDateToISO(monthString: string, type: 'start' | 'end'): string {
    // monthString format: "2024-12"
    const [year, month] = monthString.split('-');
    if (type === 'start') {
      return `${year}-${month}-01T00:00:00Z`;
    } else {
      // For end date, get the last day of the month
      const nextMonth = new Date(parseInt(year), parseInt(month), 1);
      const lastDay = new Date(nextMonth.getTime() - 1).getDate();
      return `${year}-${month}-${String(lastDay).padStart(2, '0')}T23:59:59Z`;
    }
  }
}
